/* eslint-disable consistent-return */

export default () => {
  const windowGlobal = typeof window !== 'undefined' && window;
  const documentGlobal = typeof document !== 'undefined' && document;
  if (!windowGlobal || !documentGlobal) return;

  return !!window.MSInputMethodContext && !!document.documentMode;
};
